export const benefitsPricing = [
  {
    text: <b>Cancel Anytime</b>,
    id: 1,
  },
  {
    text: (
      <>
        High-resolution exports in <b>PNG, PDF,</b> and <b>TIFF</b>
      </>
    ),
    id: 2,
  },
  {
    text: (
      <>
        <b>Unlimited</b> Scientific Illustrations
      </>
    ),
    id: 3,
  },
  {
    text: (
      <>
        <b>Unlimited</b> Creations
      </>
    ),
    id: 4,
  },
  {
    text: (
      <>
        <b>Full access</b> to the world's largest gallery of scientifically accurate Illustrations
      </>
    ),
    id: 5,
  },
  {
    text: (
      <>
        <b>Graphical Abstracts, Infographics</b> and <b>Posters</b> formats
      </>
    ),
    id: 6,
  },
  {
    text: (
      <>
        <b>Unlimited</b> External File Upload
      </>
    ),
    id: 7,
  },
  {
    text: (
      <>
        <b>Unlimited </b>downloads
      </>
    ),
    id: 8,
  },
  {
    text: (
      <>
        <b>6 different</b> illustration versions
      </>
    ),
    id: 9,
  },
  {
    text: (
      <>
        <b>Free use </b> of <b>no watermarks </b>illustrations
      </>
    ),
    id: 10,
  },
  {
    text: (
      <>
        <b>Permission</b> for professional publications
      </>
    ),
    id: 11,
  },
  {
    text: (
      <>
        <b>Restore</b> deleted files
      </>
    ),
    id: 12,
  },
  {
    text: (
      <>
        <b>Unlimited</b> start-from Templates
      </>
    ),
    id: 13,
  },
  {
    text: (
      <>
        <b>Request new Template </b>styles
      </>
    ),
    id: 14,
  },
  {
    text: (
      <>
        <b>Slides</b> and <b>Presentations</b> feature
      </>
    ),
    id: 15,
  },
  {
    text: (
      <>
        <b>Tips</b> and <b>support</b> from our Design and Infographic team
      </>
    ),
    id: 16,
  },
  {
    text: (
      <>
        <b>Priority</b> Customer Support
      </>
    ),
    id: 17,
  },
];
